import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} viewBox="0 0 29 29" {...props}>
      <rect width={29} height={29} fill={props.fillSecondary} rx={10} />
      <path
        fill={props.fillPrimary}
        d="M21.532 8.705h-3.368a2.348 2.348 0 00.811-1.758 2.464 2.464 0 00-2.521-2.4A2.229 2.229 0 0014.5 5.642a2.229 2.229 0 00-1.954-1.092 2.464 2.464 0 00-2.521 2.4 2.334 2.334 0 00.811 1.758H7.468a1.277 1.277 0 00-1.279 1.276v.8a.16.16 0 00.16.16h16.3a.16.16 0 00.16-.16v-.8a1.277 1.277 0 00-1.277-1.279zm-5.078-3.036A1.313 1.313 0 0117.8 6.948a1.313 1.313 0 01-1.346 1.278h-1.347c0-1.918.607-2.557 1.347-2.557zm-3.908 0c.743 0 1.346.639 1.346 2.557h-1.346a1.313 1.313 0 01-1.347-1.279 1.313 1.313 0 011.347-1.278zM6.828 12.302v8.87a1.282 1.282 0 001.279 1.282h5.833V11.982H7.148a.321.321 0 00-.32.32zM21.852 11.982h-6.793v10.472h5.833a1.282 1.282 0 001.283-1.282v-8.87a.321.321 0 00-.323-.32z"
      />
    </svg>
  );
}

export default SvgComponent;
